// src/components/CoreAssure/WeldAssure/WeldAssureCategoryGrid.js
//
// CoreAssure WeldAssure — 5-category grid + blockers list.
// Mirrors ReadinessCategoryGrid 1:1 with WeldAssure-specific drill-down links.

import React from "react";
import {
  Card, CardContent, Grid, Typography, Box, Stack, Chip, Button, List, ListItem, ListItemText,
} from "@mui/material";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";

const CATEGORY_FIX_LINK = {
  wps:         { label: "Open WPS Documents",  to: "/wps-documents" },
  welder_qual: { label: "Open Welders",        to: "/welders" },
  thickness:   { label: "Open WPS Documents",  to: "/wps-documents" },
  material:    { label: "Open Heat Manager",   to: "/heat-management" },
  expiration:  { label: "Open Welders",        to: "/welders" },
};

export default function WeldAssureCategoryGrid({ result, navigate }) {
  if (!result || !Array.isArray(result.categoryResults)) return null;

  return (
    <Stack spacing={2}>
      <Grid container spacing={2}>
        {result.categoryResults.map((cat) => {
          const passed = !!cat.passed;
          return (
            <Grid item xs={12} sm={6} md={4} key={cat.category}>
              <Card variant="outlined" sx={{
                borderColor: passed ? "success.light" : "error.light",
                bgcolor: passed ? "success.50" : "error.50",
              }}>
                <CardContent sx={{ pb: "12px !important" }}>
                  <Stack direction="row" spacing={1} alignItems="center" mb={0.5}>
                    {passed ? (
                      <CheckCircleOutlineIcon color="success" fontSize="small" />
                    ) : (
                      <HighlightOffIcon color="error" fontSize="small" />
                    )}
                    <Typography variant="subtitle2" sx={{ fontWeight: 700 }}>
                      {cat.label || cat.category}
                    </Typography>
                  </Stack>
                  <Typography variant="caption" color="text.secondary">
                    {cat.detail || (passed ? "Pass" : "Fail")}
                  </Typography>
                  {!passed && cat.blockerCount > 0 && (
                    <Box sx={{ mt: 1 }}>
                      <Chip
                        label={`${cat.blockerCount} blocker${cat.blockerCount === 1 ? "" : "s"}`}
                        size="small"
                        color="error"
                        variant="outlined"
                      />
                    </Box>
                  )}
                </CardContent>
              </Card>
            </Grid>
          );
        })}
      </Grid>

      {Array.isArray(result.blockers) && result.blockers.length > 0 && (
        <Card variant="outlined">
          <CardContent>
            <Typography variant="subtitle2" sx={{ fontWeight: 700, mb: 1 }}>
              Blockers ({result.blockers.length})
            </Typography>
            <List dense>
              {result.blockers.map((b, i) => {
                const fix = CATEGORY_FIX_LINK[b.category];
                return (
                  <ListItem
                    key={i}
                    secondaryAction={fix ? (
                      <Button size="small" onClick={() => navigate && navigate(fix.to)}>
                        {fix.label}
                      </Button>
                    ) : null}
                  >
                    <ListItemText
                      primary={b.reason}
                      secondary={`Category: ${b.category}`}
                    />
                  </ListItem>
                );
              })}
            </List>
          </CardContent>
        </Card>
      )}
    </Stack>
  );
}
